export default "__VITE_ASSET__BMklcp5V__"